import React, { useMemo } from 'react';
import { getSeverityColor, IAnalysisReport, sortConcernsBySeverity } from '../../logic/store/Insights/InsightsModels';
import { Collapse, Badge } from 'antd';
import styled, { useTheme } from 'styled-components';
import { FeedbackThumbs } from './Feedback';

const StyledPanelDiv = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	padding-right: 8px;

	// mobile
	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		flex-direction: column;
		flex-wrap: wrap;
	}
`;

const SeverityFeedbackContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 12px;

	// mobile
	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		align-self: flex-end;
		margin-top: 10px;
		width: auto;
	}
`;

const SeverityWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	width: 75px;
`;

const HeadlineWrapper = styled.div`
	width: 75%; // desktop default

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		width: 75%; // tablet
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		width: 100%; // mobile
	}
`;

interface IReportViewProps
{
	report: IAnalysisReport;
}

export const ReportView = (props: IReportViewProps) =>
{
	const theme = useTheme();
	const { report } = props;

	const sortedConcerns = useMemo(() =>
	{
		if (!report?.Concerns?.length)
		{
			return [];
		}

		return sortConcernsBySeverity(report.Concerns, 'desc');
	}, [report?.Concerns]);

	return (
		<div>
			{/* Collapsible panels for each concern with severity badges */}
			<Collapse destroyInactivePanel={false}>
				{sortedConcerns?.map((item, index) => 
				{
					const concernId = item.Id;
					return (
						<Collapse.Panel
							key={index}
							header={
								<StyledPanelDiv>
									<HeadlineWrapper>{item.Headline}</HeadlineWrapper>
									<SeverityFeedbackContainer>
										<div style={{ width: '50%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
											<FeedbackThumbs report={report} concernId={concernId} />
										</div>
										<SeverityWrapper>										
											<Badge
												count={item.Severity.toUpperCase()}
												style={{
													backgroundColor: getSeverityColor(item.Severity),
													borderRadius: '4px',
													fontSize: '11px',
													fontWeight: theme.fontWeights.bold,
													padding: '0 8px',
													height: '20px',
													lineHeight: '20px'
												}} />
										</SeverityWrapper>
									</SeverityFeedbackContainer>
								</StyledPanelDiv>
							}
						>
							<p>{item.Details}</p>
							{item.Recommendation?.length && <p><strong>Recommendation:</strong> {item.Recommendation}</p>}
						</Collapse.Panel>
					);
				})}
			</Collapse>
		</div>
	);
};